import { ChromeFeedback } from "#webapp/src/components/chrome-feedback";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
import { PostMessageManager } from "#webapp/src/util/post-message.util";
import { Button } from "@clockwise/design-system";
import { ArrowDropDownCircle, Edit, MoreVert, Settings } from "@clockwise/design-system/icons";
import { webappDefaultWindowName } from "@clockwise/web-commons/src/constants/route.constants";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";

export interface IProps {
  editTeam?: boolean;
  feedback?: boolean;
  settings?: boolean;
}

const MenuDivider = () => <Divider className="cw-my-0" />;

export const ChromeNavMenu = ({ editTeam, feedback, settings }: IProps) => {
  const activeView = useSelector((state: IReduxState) => state.webExtension.activeView);
  const externalEventId = useSelector(
    (state: IReduxState) => state.webExtension.activeViewEvent.externalEventId,
  );
  const calendarId = useSelector(
    (state: IReduxState) => state.webExtension.activeViewEvent.calendarId,
  );

  const [anchorEl, setAnchorEl] = useState<HTMLElement>();

  const isEventActiveView = activeView === ChromeAppWrapperView.Event;

  const handleCloseMenu = () => {
    setAnchorEl(undefined);
  };
  const goToEditEvent = () => {
    PostMessageManager.goToEventEditPage(externalEventId, calendarId);
    handleCloseMenu();
  };
  const openSettings = (goToTeam = false) => {
    if (goToTeam) {
      window.open(getUrlForFeature("teamsSettings"), webappDefaultWindowName);
    } else {
      window.open(getUrlForFeature("preferences"), webappDefaultWindowName);
    }

    handleCloseMenu();
  };

  return (
    <>
      <Tooltip title="Options">
        <Button
          variant="text"
          startIcon={MoreVert}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          cw-id="chrome-nav-menu-options-button"
        />
      </Tooltip>
      <Menu
        open={!!anchorEl}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClose={handleCloseMenu}
        onBackdropClick={handleCloseMenu}
        onEscapeKeyDown={handleCloseMenu}
      >
        {isEventActiveView && (
          <MenuItem onClick={goToEditEvent}>
            <ListItemIcon>
              <Edit className="cw-text-muted" />
            </ListItemIcon>
            <ListItemText inset primary="Edit event" />
          </MenuItem>
        )}
        {isEventActiveView && <MenuDivider />}
        {editTeam && (
          <MenuItem onClick={() => openSettings(true)}>
            <ListItemIcon>
              <Edit className="cw-text-muted" />
            </ListItemIcon>
            <ListItemText inset primary="Edit team" />
          </MenuItem>
        )}
        {!!editTeam && <MenuDivider />}
        {settings && (
          <MenuItem onClick={() => openSettings()} cw-id="chrome-nav-menu-settings-button">
            <ListItemIcon>
              <Settings className="cw-text-muted" />
            </ListItemIcon>
            <ListItemText inset primary="Settings" />
          </MenuItem>
        )}
        {!!feedback && <MenuDivider />}
        {!!feedback && <ChromeFeedback />}
        <MenuDivider />
        <MenuItem
          onClick={() => {
            PostMessageManager.closeSidebar(true);
            handleCloseMenu();
          }}
          cw-id="chrome-nav-menu-hide-clockwise-button"
        >
          <ListItemIcon>
            <div style={{ transform: "rotate(-90deg)" }}>
              <ArrowDropDownCircle className="cw-text-muted" />
            </div>
          </ListItemIcon>
          <ListItemText inset primary="Hide Clockwise" />
        </MenuItem>
      </Menu>
    </>
  );
};
